import Vue from 'vue';

const GET_SHIPMENT_DOCUMENTS_URL = '/shipment-documents';

class ShipmentDocumentService {

    async getShipmentDocuments(page) {
        return await Vue.prototype.$axios.get(GET_SHIPMENT_DOCUMENTS_URL, { params: { page } });
    }
}

export default new ShipmentDocumentService();

